import { render, staticRenderFns } from "./certifate.vue?vue&type=template&id=1c77784d&scoped=true&"
import script from "./certifate.vue?vue&type=script&lang=js&"
export * from "./certifate.vue?vue&type=script&lang=js&"
import style0 from "./certifate.vue?vue&type=style&index=0&id=1c77784d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c77784d",
  null
  
)

export default component.exports